import React, { useState } from "react";
import { Card } from "../Card";
import { Checkbox } from "../Checkbox";
import { Caption } from "../Typography";
// eslint-disable-next-line cohere-react/no-mui-styled-import
import { makeStyles, styled } from "@material-ui/core/styles";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import IconButton from "@material-ui/core/IconButton";
import { HeaderProps } from "./DefaultHeader";
import TableCell from "./TableCell";
import { Body1 } from "../Typography";

interface IProps<T> {
  allChecked: boolean;
  onCheckAll: (checked: boolean) => void;
  onDeleteAll?: () => void;
  tableColumns: HeaderProps<T>["tableColumns"];
  kebabNeeded?: boolean;
  withCard?: boolean;
  deleteIconEnabled?: boolean;
  headerTextStyle?: React.CSSProperties;
  addMargin?: boolean;
}

const useStyles = makeStyles((theme) => ({
  noCard: {
    display: "flex",
    alignItems: "center",
    backgroundColor: "inherit",
    borderWidth: 0,
    borderBottomWidth: 1,
    paddingLeft: theme.spacing(0.5),
    marginBottom: 0,
  },
  withMargin: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

export default function SecondaryHeader<T>({
  allChecked,
  onCheckAll,
  onDeleteAll,
  tableColumns,
  kebabNeeded,
  withCard = true,
  deleteIconEnabled,
  headerTextStyle,
  addMargin = false,
}: IProps<T>) {
  const [anchorKebab, setAnchorKebab] = useState(null);
  const classes = useStyles();
  return withCard ? (
    <TableHeaderCard>
      {tableColumns.map((column, index) => (
        <TableCell width={column.width} themedPaddingRight={column.themedPaddingRight} key={index}>
          {column.name === "Selected" ? (
            <Checkbox checked={allChecked} onChange={() => onCheckAll(!allChecked)} />
          ) : (
            <Caption>{column.name}</Caption>
          )}
        </TableCell>
      ))}
      {kebabNeeded && !!onDeleteAll ? (
        <IconButtonTableCell onClick={(event: any) => setAnchorKebab(event.currentTarget)}>
          <MoreVertIcon />
        </IconButtonTableCell>
      ) : (
        <></>
      )}
      {!!onDeleteAll && (
        <Menu
          id="simple-menu"
          anchorEl={anchorKebab}
          keepMounted
          open={Boolean(anchorKebab)}
          onClose={() => setAnchorKebab(null)}
        >
          <MenuItem onClick={() => onDeleteAll()}>Delete</MenuItem>
        </Menu>
      )}
    </TableHeaderCard>
  ) : (
    <div className={`${classes.noCard} ${addMargin ? classes.withMargin : ""}`}>
      {tableColumns.map((column, index) => (
        <TableCell width={column.width} themedPaddingRight={column.themedPaddingRight} key={index}>
          {column.name === "Selected" ? (
            <Checkbox checked={allChecked} onChange={() => onCheckAll(!allChecked)} />
          ) : (
            <Body1 style={headerTextStyle}>{column.name}</Body1>
          )}
        </TableCell>
      ))}
      {!kebabNeeded && !!onDeleteAll && (
        <IconButton onClick={() => onDeleteAll()} style={{ alignSelf: "flex-end", zIndex: 1 }}>
          {deleteIconEnabled ? <DeleteIcon /> : <DeleteIcon color="disabled" />}
        </IconButton>
      )}
      {kebabNeeded && !!onDeleteAll ? (
        <IconButtonTableCell onClick={(event: any) => setAnchorKebab(event.currentTarget)}>
          <MoreVertIcon />
        </IconButtonTableCell>
      ) : (
        <></>
      )}
      {!!onDeleteAll && (
        <Menu
          id="simple-menu"
          anchorEl={anchorKebab}
          keepMounted
          open={Boolean(anchorKebab)}
          onClose={() => setAnchorKebab(null)}
        >
          <MenuItem onClick={() => onDeleteAll()}>Delete</MenuItem>
        </Menu>
      )}
    </div>
  );
}

// eslint-disable-next-line cohere-react/no-mui-styled-import
const TableHeaderCard = styled(Card)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  backgroundColor: "inherit",
  marginBottom: theme.spacing(3),
  padding: theme.spacing(2, 3, 2, 3),
  borderWidth: 0,
  borderBottomWidth: 1,
}));

// eslint-disable-next-line cohere-react/no-mui-styled-import
const IconButtonTableCell = styled(IconButton)(({ theme }) => ({
  alignItems: "center",
}));
